import { createEntityAdapter } from '@ngrx/entity';
import { IDocument } from 'src/app/models/document';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IDocumentLibraryState } from '../../state/document-library.state';
import { IAppState } from '../../state/app.state';

export const getDocumentLibraryState = createFeatureSelector<IAppState, IDocumentLibraryState>('documentLibrary');

export const documentLibraryAdapter = createEntityAdapter<IDocument>({
    selectId: (document: IDocument) => document.myDocumentId
});

export const selectDocumentLibraryState = createSelector(
    getDocumentLibraryState,
    (state) => {
        return state;
    }
);
